import { Controller } from "@hotwired/stimulus";
// Supprimez ces deux lignes d'importation
// import authImage from "../../images/auth-go-4-school-image.svg";
// import authImageReversed from "../../images/auth-go-4-school-image-reversed.svg";

export default class extends Controller {
  static targets = ["leftImage", "leftBlock", "rightTopImage", "rightBlock"];
  // Ajoutez cette ligne pour les values
  static values = {
    authImage: String,
    authImageReversed: String
  }

  connect() {
    this.defineLayout();
  }

  defineLayout() {
    // Les chemins réels de l'application sont /sign_in et /sign_up (cf.
    // config/routes/auth.rb) ; les variantes /users/... sont celles de Devise,
    // conservées au cas où l'on y reviendrait.
    const _2BlocksRoutes = [
      "/sign_in",
      "/sign_up",
      "/users/sign_up/success",
      "/users/sign_in",
      "/users/sign_up",
      ...["fr", "en"].flatMap((locale) => [
        `/${locale}/sign_in`,
        `/${locale}/sign_up`,
        `/${locale}/users/sign_up/success`,
        `/${locale}/users/sign_in`,
        `/${locale}/users/sign_up`,
      ]),
    ];
    const reveredImageRoutes = [
      "/users/sign_up/success",
      "/fr/users/sign_up/success",
      "/en/users/sign_up/success",
    ];
    const noRightTopImageRoutes = [
      "/reset_password",
      "/users/password/edit",
      "/reset_password/success",
      "/fr/reset_password",
      "/fr/users/password/edit",
      "/fr/reset_password/success",
      "/en/reset_password",
      "/en/users/password/edit",
      "/en/reset_password/success",
    ];

    const pathname = window.location.pathname;

    // For page with have 2 columns: image on left side white block on right side
    if (_2BlocksRoutes.includes(pathname)) {
      // Setting the max width of the white block on the right side
      this.rightBlockTarget.classList.add("max-w-[528px]");

      // Setting images to display
      if (reveredImageRoutes.includes(pathname)) {
        // If the reversed image should be use
        // Utilisez this.authImageReversedValue au lieu de authImageReversed
        this.leftImageTarget.src = this.authImageReversedValue;
        this.leftImageTarget.classList.add("aspect-[653/563]");
        this.rightTopImageTarget.src = this.authImageReversedValue;
        this.rightTopImageTarget.classList.add("aspect-[653/563]");
      } else {
        // use the non reversed image
        // Utilisez this.authImageValue au lieu de authImage
        this.leftImageTarget.src = this.authImageValue;
        this.leftImageTarget.classList.add("aspect-[547.78/465]");
        this.rightTopImageTarget.src = this.authImageValue;
        this.rightTopImageTarget.classList.add("aspect-[547.78/465]");
      }
    } else {
      // If we use the one column layout

      // Remove the left block
      this.leftBlockTarget?.remove();

      // Set top right image
      // Utilisez this.authImageValue au lieu de authImage
      this.rightTopImageTarget.src = this.authImageValue;
      this.rightTopImageTarget.classList.add("aspect-[547.78/465]");
      if (noRightTopImageRoutes.includes(pathname)) {
        this.rightTopImageTarget.classList.add("hidden");
      } else {
        this.rightTopImageTarget.classList.remove("xl:hidden");
      }

      // Set the block max width
      this.rightBlockTarget.classList.add("max-w-[528px]");
    }
  }
}
